
import styles from "./index.module.scss";
import Modal from "../../molecules/Modal";
import CloseIcon from "../../../assets_v2/icons/CloseIcon";

export default function RcmpModalAlert(props) {
    const { isOpen, icon, fnOnClose, children, color, modalCustomWidth, nOverlayZindex } = props
    return (
        <Modal className={styles.modalAlertArea} isOpen={isOpen} onClose={fnOnClose} size="sm" modalCustomWidth={modalCustomWidth} nOverlayZindex={nOverlayZindex}>
            <Modal.Content style={{ width: "100%" }}>
                <div className={styles.modalAlertContainer}>
                    <div className={styles.iconContainer}>
                        <div className={styles.close} onClick={fnOnClose}>
                            <CloseIcon
                                fill={"#22272D"}
                            />
                        </div>
                        <div className={styles.trashIconContainer} style={{ backgroundColor: color }}>
                            {icon}
                        </div>
                    </div>
                    {children}
                </div>
            </Modal.Content>
        </Modal>
    )
}